import _regeneratorRuntime from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { mapState, mapActions } from "vuex";
import helper from "@/libs/helper.js";
import Env from "@/Env.js";
console.log("#debug#🚀 ~ file: index.vue:47 ~ Env:", Env);
export default {
  computed: _objectSpread({}, mapState("d2admin/user", ["info"])),
  data: function data() {
    return {
      user: {},
      activeCodeVisible: false,
      form: {
        code: ""
      },
      version: Env.version
    };
  },
  created: function created() {
    this.getUserData();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/account", ["logout"])), {}, {
    openMinCode: function openMinCode() {
      this.$router.push({
        path: "/messageSetting"
      });
    },
    changePwd: function changePwd() {
      this.$router.push({
        path: "/adminSetting"
      });
    },
    getUserData: function getUserData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, data, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = helper.apiHost + helper.apiUrl.getUserData;
              data = {};
              _context.next = 4;
              return _this.axios(url, {
                params: data
              });
            case 4:
              response = _context.sent;
              if (response.code == 0) {
                _this.user = response.data;
              } else {}
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * @description 登出
     */
    logOff: function logOff() {
      this.logout({
        confirm: true
      });
    }
  })
};